import { render } from "./Acknowledge.vue?vue&type=template&id=70d460da&ts=true"
import script from "./Acknowledge.vue?vue&type=script&lang=ts"
export * from "./Acknowledge.vue?vue&type=script&lang=ts"

import "./Acknowledge.vue?vue&type=style&index=0&id=70d460da&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__